import React, { useEffect, useState } from 'react';
import { adminNewsletter } from '../../lib/api';
import { Loader2, Download, Copy, Check } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { useToast } from '../../hooks/use-toast';

const AdminNewsletter = () => {
  const [subs, setSubs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [copied, setCopied] = useState(false);
  const { toast } = useToast();

  useEffect(() => { adminNewsletter().then(setSubs).catch(console.error).finally(() => setLoading(false)); }, []);

  const copyAll = async () => {
    await navigator.clipboard.writeText(subs.map(s => s.email).join(', '));
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
    toast({ title: 'Copied!', description: `${subs.length} emails copied to clipboard.` });
  };

  const exportCsv = () => {
    const csv = ['email,date', ...subs.map(s => `${s.email},${s.created_at || ''}`)].join('\n');
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url; a.download = `newsletter-${new Date().toISOString().slice(0,10)}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  if (loading) return <div className="flex justify-center py-20"><Loader2 className="w-8 h-8 animate-spin text-neutral-400" /></div>;

  return (
    <div>
      <div className="flex items-center justify-between mb-5 flex-wrap gap-3">
        <div>
          <h1 className="text-2xl font-black">Newsletter Subscribers</h1>
          <p className="text-sm text-neutral-500">{subs.length} subscribers</p>
        </div>
        <div className="flex gap-2">
          <Button variant="outline" onClick={copyAll} disabled={!subs.length}>
            {copied ? <Check className="w-4 h-4 mr-1" /> : <Copy className="w-4 h-4 mr-1" />}
            Copy all emails
          </Button>
          <Button onClick={exportCsv} disabled={!subs.length} className="bg-[#0a0a0a]">
            <Download className="w-4 h-4 mr-1" /> Export CSV
          </Button>
        </div>
      </div>

      {subs.length === 0 ? (
        <div className="bg-white rounded-lg p-12 text-center border">
          <p className="text-neutral-500">No subscribers yet.</p>
        </div>
      ) : (
        <div className="bg-white rounded-lg border overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-neutral-50 text-left text-xs uppercase tracking-wider text-neutral-500">
              <tr><th className="px-4 py-3">Email</th><th className="px-4 py-3">Subscribed</th></tr>
            </thead>
            <tbody>
              {subs.map(s => (
                <tr key={s.id || s.email} className="border-t">
                  <td className="px-4 py-3 font-medium">{s.email}</td>
                  <td className="px-4 py-3 text-neutral-500 text-xs">{s.created_at ? new Date(s.created_at).toLocaleString() : '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AdminNewsletter;
